import { call, takeEvery } from 'redux-saga/effects';
import { toast } from 'react-semantic-toasts';
import { SHOW_TOAST } from 'state/actionTypes';

export function* showToast({ payload }) {
  const { type, message, description, timeout, options } = payload;
  yield call(toast, {
    type,
    title: message,
    description,
    time: timeout,
    ...options,
  });
}

export default function* saga() {
  yield takeEvery(SHOW_TOAST, showToast);
}
